import React, { useState, useEffect, useRef } from 'react';
import {
  Link,
  useNavigate,
  useLocation
} from 'react-router-dom';
import {
  Container, Row, Col,
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Button
} from 'reactstrap';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n/';


import './Navigation.css';
import LanguageSwitcher from "../99_untils/LanguageSwitcher";
// import LanguageWrapper from "../99_untils/LanguageWrapper";

import logoWhite from './images/dash-logo-white.png';
import logoBlack from './images/dash-logo-black.png';



export default function NavigationDesktop({ colorWhiteLogo = false, bgWhiteConfig = false}) {
  // console.log("Navigation constructor started ")
  const isMountedRef = useRef();
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const location = useLocation();

  const [curLang, setCurLang] = useState(i18n.language);
  const [hasScrolledDown, setHasScrolledDown] = useState(false);
  const [isHomePage, setIsHomePage] = useState(false);
  const [langSwitchOn, setLangSwitchOn] = useState(false);
  
  const navigate = useNavigate();
  
  // Check if current URL contains 'minigameselect'
  const curPageMiniGameSelect = location.pathname.includes('minigameselect');
  // Navigation display states:
  // 1. Normal: black logo, transparent bg
  // 2. Scrolled: black logo, white bg (after scroll >= 60)
  // 3. White mode: white logo, transparent bg (when colorWhiteLogo prop is true)
  // 4. White mode + scrolled: white logo, white bg
  // 5. Combination handling for all cases

  // const isHomePage = location.pathname === '/';

  // let isHomePage = false;


  const handleScroll = () => {
    const scroll = window.scrollY;
    setHasScrolledDown(scroll >= 60);
  }

  // Update location.pathname if home page shows lang change
  useEffect(() => {
    if(location.pathname === `/${curLang}/`) {
      setLangSwitchOn(true);
    } else if(location.pathname === `/${curLang}/minigame`)
    { 
      setLangSwitchOn(true);
    } else{
      setLangSwitchOn(false);
    }
    // if(location.pathname === `/${curLang}/`) {
    //   setIsHomePage(true);
    // }else{
    //   setIsHomePage(false);
    // }
    // setLangSwitchOn
  }, [location.pathname]);

  // Update current language when i18n changes
  useEffect(() => {
    setCurLang(i18n.language);
  }, [i18n.language]);

  // Set up scroll listener
  useEffect(() => {
    isMountedRef.current = true;

    // console.log("Navigation useEffect - isHomePage:", isHomePage);
    
    return () => {
      isMountedRef.current = false;
    };
  }, []);


  return (
    <div className="nav-wrap nav-desktop-wrap">
      <Navbar expand="xs">
        <NavbarBrand href={`/${curLang}/`}>
          {/* White logo - shown when colorWhiteLogo prop is true */}
          
          {/* Black logo - shown by default and when not in white mode */}
          <img
            alt="logo dark"
            className={`logo }`}
            src={logoWhite}
            style={{
              height: 'auto',
              width: 40
            }}
          />
        </NavbarBrand>


        
        {/* <Nav navbar>
          <NavItem className="ms-auto">
            <LanguageSwitcher />
          </NavItem>
        </Nav>  */}
      </Navbar>
    </div>

  );

}
